import { render, staticRenderFns } from "./statisticsbutton.vue?vue&type=template&id=567639c0&scoped=true&v-else=true"
import script from "./statisticsbutton.vue?vue&type=script&lang=js"
export * from "./statisticsbutton.vue?vue&type=script&lang=js"
import style0 from "./statisticsbutton.vue?vue&type=style&index=0&id=567639c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567639c0",
  null
  
)

export default component.exports